import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment} from "../../environments/environment";
import { Observable } from "rxjs";
import {Paziente} from "../_interfaces/paziente";
import { shareReplay } from 'rxjs/operators';
import {CookieService} from "./cookie.service";

@Injectable({
    providedIn: 'root',
})
export class AuthService {

    private apiURL = environment.apiURL;
    private cache$: Observable<any> | null = null;
    private changePasswordFlag: boolean = false;

    constructor(private http: HttpClient, private cookieService: CookieService) {}

    clearCache() {
        this.cache$ = null;
    }

    /**
     * Check Email
     * @param email
     */
    checkEmail(email: String) : Observable<HttpResponse<any>> {
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        return this.http.post<any>(`${this.apiURL}/checkemail`, { email: email }, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }


    /**
     * Login
     * @param email
     * @param password
     */
    login(email: String, password: String, code?: string|null) : Observable<HttpResponse<any>> {
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        return this.http.post<any>(`${this.apiURL}/login`, { email: email, password: password, code: code}, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }

    /**
     * Login Otp
     * @param email
     * @param otp
     */
    loginOtp(email: String, otp: String , code?: string|null) : Observable<HttpResponse<any>> {
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        return this.http.post<any>(`${this.apiURL}/loginotp`, { email: email, double_optin_code: otp, code: code}, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }

    /**
     * Invio codice double opt-in
     * @param code
     */
    doubleoptin(code: String) : Observable<HttpResponse<any>> {
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        return this.http.post<any>(`${this.apiURL}/doubleoptin`, { code: code }, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }

    /**
     * Invio nuovo codice double opt-in via SMS
     * @param code
     */
    doubleoptinCode(email?: String) : Observable<HttpResponse<any>> {
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        return this.http.put<any>(`${this.apiURL}/doubleoptin/code`, { email: email }, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }

    /**
     * Logout
     */
    logout(log?: string) {
        this.cache$ = null;
        let params;
        if (log) {
            params = '?log=' + log;
        } else {
            params = '';
        }
        return this.http.get<any>(`${this.apiURL}/logout` + params, {
            withCredentials: true,
            observe: 'response'
        });

    }

    /**
     * Richiede reset della password
     * @param email
     */
    resetPassword(email: String, code?: String) {
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        return this.http.post<any>(`${this.apiURL}/reset-password`, { email: email, code: code }, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }

    /**
     * Richiede l'invio di una nuova password temporanea
     */
    sendCode(email?: string) {
        let body = {};
        if (email) {
            body = { email: email };
        }
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        return this.http.put<any>(`${this.apiURL}/user/send-code`, body, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }


    /**
     * Richiede l'invio di una OTP per il cambio password
     */
    sendChangePasswordOtpCode(code?: string) {
        let body = {};
        if (code) {
            body = { code: code };
        }
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        return this.http.put<any>(`${this.apiURL}/change-password-otp`, body, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }


    /**
     * Cambio password da reset link
     * @param code
     * @param password
     */
    changePassword(code: string|null, password: string, otp: string) {
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        return this.http.post<any>(`${this.apiURL}/change-password`, { code: code, password: password, otp: otp }, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }

    /**
     * Cambio password da interfaccia
     * @param current password corrente
     * @param password nuova password
     * @param confirm conferma nuova password
     */
    updatePassword(current: string, confirm: string, password: string) {
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        return this.http.put<any>(`${this.apiURL}/user/change-password`, { current_password: current, password: password, password_confirmation: confirm }, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }

    updateOptions(sms: boolean, double_opt_in: boolean) {
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        return this.http.put<any>(`${this.apiURL}/user/change-options`, { sms: sms, double_opt_in: double_opt_in }, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }

    /**
     * Preleva i dati dell'utente e li mette in cache$
     */
    getUserData(mode?: string): Observable<any> {

        let url = this.apiURL + '/user';
        if (mode) {
            url = url + '/' + mode;
        }
        if (this.cache$) {
            return this.cache$;
        }
        this.cache$ = this.http.get<any>(url, {
            withCredentials: true,
            observe: 'response'
        }).pipe(
            shareReplay(1)
        );

        return this.cache$;
    }

    /**
     * Preleva i dati dell'utente
     */
    getUser() {
        return this.http.get<any>(`${this.apiURL}/user`, {
            withCredentials: true,
            observe: 'response'
        });
    }

    /**
     * Invia i dati per la registrazione del paziente
     * @param paziente
     */
    register(paziente: Paziente, validate_only_mandatory_conditions: boolean = false) {
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        var data = {...paziente, validate_only_mandatory_conditions: validate_only_mandatory_conditions};
        return this.http.post<any>(`${this.apiURL}/register`, data, {
            headers,
            withCredentials: true,
            observe: 'response'
        })
    }


}
